





























































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class ShowsGuestTableParams extends Vue {
  @Prop({ type: Boolean, default: true }) comment!: boolean;
  @Prop({ type: Boolean, default: true }) gender!: boolean;
  @Prop({ type: Boolean, default: true }) email!: boolean;
  @Prop({ type: Boolean, default: true }) order_number!: boolean;
  @Prop({ type: Boolean, default: true }) ad!: boolean;
  @Prop({ type: Boolean, default: true }) room!: boolean;
  @Prop({ type: Boolean, default: true }) phone_number!: boolean;
  @Prop({ type: Boolean, default: true }) birthday!: boolean;
  @Prop({ type: Boolean, default: true }) document!: boolean;
  @Prop({ type: Boolean, default: true }) age!: boolean;
  @Prop({ type: Boolean, default: true }) check!: boolean;
  @Prop({ type: Boolean, default: true }) table!: boolean;
  @Prop({ type: Boolean, default: true }) zit!: boolean;

  // shows
  show_comment = this.comment;
  show_gender = this.gender;
  show_email = this.email;
  show_order_number = this.order_number;
  show_ad = this.ad;
  show_room = this.room;
  show_phone_number = this.phone_number;
  show_birthday = this.birthday;
  show_document = this.document;
  show_age = this.age;
  show_check = this.check;
  show_table = this.table;
  show_zit = this.zit;

  @Watch("show_table")
  setshow_table(): void {
    this.$emit("show_table", this.show_table);
  }
  @Watch("show_zit")
  setshow_zit(): void {
    this.$emit("show_zit", this.show_zit);
  }
  @Watch("show_age")
  setshow_age(): void {
    this.$emit("show_age", this.show_age);
  }
  @Watch("show_check")
  setshow_check(): void {
    this.$emit("show_check", this.show_check);
  }
  @Watch("age")
  getshow_age(): void {
    this.show_age = this.age;
  }

  @Watch("show_document")
  setshow_document(): void {
    this.$emit("show_document", this.show_document);
  }
  @Watch("document")
  getshow_document(): void {
    this.show_document = this.document;
  }

  @Watch("show_birthday")
  setshow_birthday(): void {
    this.$emit("show_birthday", this.show_birthday);
  }
  @Watch("birthday")
  getshow_birthday(): void {
    this.show_birthday = this.birthday;
  }

  @Watch("show_phone_number")
  setshow_phone_number(): void {
    this.$emit("show_phone_number", this.show_phone_number);
  }
  @Watch("phone_number")
  getshow_phone_number(): void {
    this.show_phone_number = this.phone_number;
  }

  @Watch("show_room")
  setshow_room(): void {
    this.$emit("show_room", this.show_room);
  }
  @Watch("room")
  getshow_room(): void {
    this.show_room = this.room;
  }

  @Watch("show_ad")
  setshow_ad(): void {
    this.$emit("show_ad", this.show_ad);
  }
  @Watch("ad")
  getshow_ad(): void {
    this.show_ad = this.ad;
  }

  @Watch("show_order_number")
  setshow_order_number(): void {
    this.$emit("show_order_number", this.show_order_number);
  }
  @Watch("order_number")
  getshow_order_number(): void {
    this.show_order_number = this.order_number;
  }

  @Watch("show_email")
  setshow_email(): void {
    this.$emit("show_email", this.show_email);
  }
  @Watch("email")
  getshow_email(): void {
    this.show_email = this.email;
  }

  @Watch("show_comment")
  setshow_comment(): void {
    this.$emit("show_comment", this.show_comment);
  }
  @Watch("comment")
  getshow_comment(): void {
    this.show_comment = this.comment;
  }

  @Watch("show_gender")
  setshow_gender(): void {
    this.$emit("show_gender", this.show_gender);
  }
  @Watch("gender")
  getshow_gender(): void {
    this.show_gender = this.gender;
  }
}
